module.exports = __webpack_public_path__ + "img/equa.5c337294.svg";